import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  Self,
} from '@angular/core';
import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';

@Directive({
  selector: '[ngxTelInputPlaceholder]',
})
export class NgxTelInputPlaceholderDirective implements AfterViewInit {
  constructor(
    @Self() private ngxIntlTelInput: NgxIntlTelInputComponent,
    private cdRef: ChangeDetectorRef
  ) {}

  public ngAfterViewInit(): void {
    const countryBY = this.ngxIntlTelInput.allCountries.find((country) => {
      return country.iso2 === 'by';
    });
    countryBY.placeHolder = '+375 29 123 45 67';
    this.cdRef.detectChanges();
  }
}
